
export class EquipmentOffer {
    constructor(data) {
        this.equipment_offering_external_id = '';
        this.has_equipment = '';
        this.project_name = '';
        this.terminal_netowrk_name = '';
        this.dialling_instructions = '';
        this.terminal_application_type = '';
        this.auto_settle = '';
        this.auto_settle_time = '';
        this.amex_settlement = '';
        this.training = '';
        this.equipment_ip = [];
        this.payeezy = '';
        this.payeezy_effective_date = '';
        this.transarmor = '';
        this.transarmor_service_type = '';
        this.transarmor_hierarchy = '';
        this.transarmor_token_type = '';
        this.transarmor_encryption = '';
        this.vsp_domain = '';
        this.vsp_brand = '';
        this.descriptor_name = '';
        this.descriptor_city = '';
        this.descriptor_state = '';
        this.customer_service_number = '';
        this.equipment_lists = [];
        this.selected_offer = '';
        this.equipment_and_bundle_list = [];
        if (!!data) {
            this.setData(data);
        }
    }

    setData(data) {
        let keys = Object.keys(data);
        keys.map(f => {
            if(f === 'equipment_lists') {
                let equipment_lists = data[f].map(obj => {
                    return new Equipment(obj);
                });
                this[f] = !!equipment_lists ? equipment_lists : [];
            } else {
                this[f] = !!data[f] ? data[f] : '';
            }
        });
    }
}

export class EquipmentBundle {
    constructor(data) {
        this.equipment_bundle_external_id = '';
        this.bundle_items = [];
        if (!!data) {
            this.setData(data);
        }
    }

    setData(data) {
        let keys = Object.keys(data);
        keys.map(f => {
            if(f === 'bundle_items') {
                this[f] = data[f].map(obj => {return new BundleItem(obj);});
            } else {
                this[f] = !!data[f] ? data[f] : '';
            }
        });
    }
}

export class BundleItem {
    constructor(data) {
        this.equipment = new Equipment();
        this.equipment_bundle_item_external_id = '';
        this.bundle_name = '';
        this.features = [];
        this.billing_method_external_id = '';
        this.billing_min = '';
        this.billing_max = '';
        this.is_renewal_billing = '';
        this.renewal_billing_min = '';
        this.renewal_billing_max = '';
        this.external_terminal_id = '';
        this.terminal_unit_price = '';
        this.terminal_renewal_price = '';
        this.terminal_quantity = '';
        this.is_disabled = '';
        if (!!data) {
            this.setData(data);
        }
    }

    setData(data) {
        let keys = Object.keys(data);
        keys.map(f => {
            if(f === 'features') {
                this[f] = data[f].map(obj => {
                    return new Feature(obj);
                })
            }
            else if (f === 'equipment') {
                this[f] = new Equipment(data[f]);
            }
            else {
                this[f] = !!data[f] ? data[f] : '';
            }
        });
    }
}

export class Feature {
    constructor(data) {
        this.feature_external_id = '';
        this.selected = '';
        this.value = '';
        this.values = [];
        if (!!data) {
            this.setData(data);
        }
    }

    setData(data) {
        let keys = Object.keys(data);
        keys.map(f => {
            this[f] = !!data[f] ? data[f] : '';
        });
    }
}

export class EquipmentFeature {
    constructor(data) {
        this.equipment_feature_external_id = '';
        this.feature_type = '';
        this.quantity = '';
        this.amount = '';
        this.equipment_feature_status_code = '';
        if (!!data) {
            this.setData(data);
        }
    }

    setData(data) {
        let keys = Object.keys(data);
        keys.map(f => {
            this[f] = !!data[f] ? data[f] : '';
        });
    }
}

export class Equipment {
    constructor(data) {
        this.dcc_supplier = '';
        this.dcc_supplier_code = '';
        this.equipment_api_code = '';
        this.equipment_external_id = '';
        this.equipment_manufacturer = '';
        this.equipment_name = '';
        this.equipment_ref = '';
        this.unit_price = '';
        this.quantity = '';
        this.billing_method = '';
        this.is_dcc = '';
        this.is_service = '';
        this.supplier_code = '';

        if (!!data) {
            this.setData(data);
        }
    }


    setData(data) {
        let keys = Object.keys(data);
        keys.map(f => {
            this[f] = !!data[f] ? data[f] : '';
        });
    }
}

